import { useNavigate } from '@fukuri-admins/hooks/common';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useSearchParams } from 'react-router-dom';
import { ROUTES } from '~/utils/routes';
import { useGetStressAssessmentList } from './useGetStressAssessmentList';

type IUseStressAssessmentList = () => {
  state: {
    data: ReturnType<typeof useGetStressAssessmentList>['data'];
    isLoading: boolean;
    currentPage: number;
    totalPage: number;
    totalCount: number;
  };
  actions: {
    handlePageChange: (page: number) => void;
    handleRowClick: (id: number) => void;
  };
};

export const useStressAssessmentList: IUseStressAssessmentList = () => {
  const navigate = useNavigate();
  const [filterParams, setFilterParams] = useSearchParams();
  const threeLetterCode = getThreeLetterCode();

  const rawPage = Number.parseInt(filterParams.get('page') ?? '1', 10);
  const currentPage = Number.isNaN(rawPage) || rawPage < 1 ? 1 : rawPage;

  const { data, totalPage, totalCount } = useGetStressAssessmentList({
    threeLetterCode,
    page: String(currentPage),
  });

  const handleRowClick = (id: number) => {
    navigate(ROUTES.STRESS_ASSESSMENTS.REPORTS.replace(':id', String(id)));
  };

  const handlePageChange = (page: number) => {
    const newParams = new URLSearchParams(filterParams);
    newParams.set('page', page.toString());
    setFilterParams(newParams);
  };

  return {
    state: {
      data,
      isLoading: !data,
      currentPage,
      totalPage,
      totalCount,
    },
    actions: {
      handlePageChange,
      handleRowClick,
    },
  };
};
